import { authGuard } from '@auth0/auth0-vue'

import { RouteName } from './RouteName'

import type { BuildingId } from '@/types/BuildingId'
import type { OrganizationId } from '@/types/OrganizationId'

const guard = window.Cypress && localStorage.getItem('cypress_bypass_auth') ? undefined : authGuard

enum layout {
  overflow = 'overflow',
  noOverflow = 'noOverflow',
}

const routes = [
  {
    path: '/',
    name: RouteName.rootView,
    component: () => import('@/views/TheRootView/TheRootView.vue'),
    beforeEnter: guard,
    meta: {
      title: 'Hearsee',
      layout: layout.noOverflow,
    },
  },
  {
    path: '/forbidden',
    name: RouteName.forbidden,
    component: () => import('@/views/TheForbiddenView/TheForbiddenView.vue'),
    meta: {
      title: 'Forbidden',
      layout: layout.noOverflow,
    },
  },
  {
    path: '/organizations/:organizationId',
    name: RouteName.organizationView,
    component: () => import('@/views/TheOrganizationView/TheOrganizationView.vue'),
    props: true,
    beforeEnter: guard,
    meta: {
      title: 'Organization',
      layout: layout.noOverflow,
    },
  },
  {
    path: '/organizations/:organizationId/outdoor/mapping',
    name: RouteName.theOutdoorMappingView,
    component: () => import('@/views/TheOutdoorMappingView/TheOutdoorMappingView.vue'),
    props: true,
    beforeEnter: guard,
    meta: {
      title: 'Outdoor Mapping',
      layout: layout.noOverflow,
    },
  },
  {
    path: '/organizations/:organizationId/buildings/:buildingId/mapping',
    name: RouteName.theMappingView,
    component: () => import('@/views/TheIndoorMappingView/TheIndoorMappingView.vue'),
    props: (route: { params: { buildingId: string; organizationId: OrganizationId } }) => ({
      buildingId: route.params.buildingId as BuildingId,
      organizationId: route.params.organizationId as OrganizationId,
    }),
    beforeEnter: guard,
    meta: {
      title: 'Building Mapping', // TODO: use building name instead of generic title
      layout: layout.noOverflow,
    },
  },
]

export { routes, layout }
